import { Goal } from './Goal';

export const kind = 'Restart';

export type Restart = Goal<typeof kind>;
